import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextAttachment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7418_53875)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 4.8C0 2.14903 2.14903 0 4.8 0H17.0059C17.6424 0 18.2529 0.252856 18.7029 0.702944L23.2971 5.29706C23.7471 5.74714 24 6.35759 24 6.99411V19.2C24 21.851 21.851 24 19.2 24H4.8C2.14903 24 0 21.851 0 19.2V4.8ZM9.6 14.4C9.6 14.0686 9.86863 13.8 10.2 13.8H14.4C14.7314 13.8 15 14.0686 15 14.4C15 14.7314 14.7314 15 14.4 15H10.2C9.86863 15 9.6 14.7314 9.6 14.4ZM16.8 13.8C16.4686 13.8 16.2 14.0686 16.2 14.4C16.2 14.7314 16.4686 15 16.8 15H18.6C18.9314 15 19.2 14.7314 19.2 14.4C19.2 14.0686 18.9314 13.8 18.6 13.8H16.8ZM9.6 18C9.6 17.6686 9.86863 17.4 10.2 17.4H11.4C11.7314 17.4 12 17.6686 12 18C12 18.3314 11.7314 18.6 11.4 18.6H10.2C9.86863 18.6 9.6 18.3314 9.6 18ZM13.8 17.4C13.4686 17.4 13.2 17.6686 13.2 18C13.2 18.3314 13.4686 18.6 13.8 18.6H16.2C16.5314 18.6 16.8 18.3314 16.8 18C16.8 17.6686 16.5314 17.4 16.2 17.4H13.8ZM2.78182 11.6182V12.6784H4.93977V18.6H6.19432V12.6784H8.35227V11.6182H2.78182Z",
			fill: "#4F49BA"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M16.5 0H17.0059C17.6424 0 18.2529 0.252856 18.7029 0.702944L24 6H18.9C17.5745 6 16.5 4.92548 16.5 3.6V0Z",
			fill: "white",
			fillOpacity: .16
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7418_53875",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgTextAttachment;
